export interface HasGroupPermissions {
  groupItems: string[];
  groupItemIds: string[];
}

export interface HasValidGroupPermissionOptions<T extends HasGroupPermissions = HasGroupPermissions> {
  properties: T;
  defaultGroupName: string;
  userGroups: Array<{ name: string; id: string }>;
}

export function hasValidGroupPermission<T extends HasGroupPermissions>(
  options: HasValidGroupPermissionOptions<T>
): boolean {
  const { properties, defaultGroupName, userGroups } = options;
  const { groupItems, groupItemIds } = properties;

  if (groupItems.includes(defaultGroupName)) {
    return true;
  }

  return userGroups.some((group) => groupItems.includes(group.name) && groupItemIds.includes(group.id));
}
